import { FailureCodeEnum as InvoiceDisputedFailureCode } from 'anchor-ts-infra/src/dto/invoice';
// eslint-disable-line @typescript-eslint/no-explicit-any

export let BillingTriggerType = /*#__PURE__*/function (BillingTriggerType) {
  BillingTriggerType["OnApproval"] = "approval";
  BillingTriggerType["Ongoing"] = "ongoing";
  BillingTriggerType["OneTimeManual"] = "oneTimeManual";
  BillingTriggerType["RepeatableManual"] = "repeatableManual";
  BillingTriggerType["OneTimeInStages"] = "oneTimeInStages";
  return BillingTriggerType;
}({});
export let PlaidAccountType = /*#__PURE__*/function (PlaidAccountType) {
  PlaidAccountType["Depository"] = "depository";
  PlaidAccountType["Credit"] = "credit";
  PlaidAccountType["Loan"] = "loan";
  PlaidAccountType["Investment"] = "investment";
  PlaidAccountType["Other"] = "other";
  return PlaidAccountType;
}({});
export let PlaidDepositoryAccountSubtype = /*#__PURE__*/function (PlaidDepositoryAccountSubtype) {
  PlaidDepositoryAccountSubtype["Checking"] = "checking";
  PlaidDepositoryAccountSubtype["Savings"] = "savings";
  PlaidDepositoryAccountSubtype["HSA"] = "hsa";
  PlaidDepositoryAccountSubtype["CD"] = "cd";
  PlaidDepositoryAccountSubtype["MoneyMarket"] = "money market";
  PlaidDepositoryAccountSubtype["Paypal"] = "paypal";
  PlaidDepositoryAccountSubtype["Prepaid"] = "prepaid";
  PlaidDepositoryAccountSubtype["CashManagement"] = "cash management";
  PlaidDepositoryAccountSubtype["EBT"] = "ebt";
  return PlaidDepositoryAccountSubtype;
}({});

/** @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */

/** @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */

/** @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */

/** @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */

export let VobQboState = /*#__PURE__*/function (VobQboState) {
  VobQboState["Started"] = "started";
  VobQboState["ConnectionTriggered"] = "connectionTriggered";
  VobQboState["Canceled"] = "canceled";
  VobQboState["Done"] = "done";
  return VobQboState;
}({});
export let StartBillingOnEnum = /*#__PURE__*/function (StartBillingOnEnum) {
  StartBillingOnEnum["SkipBillingOnAcceptance"] = "skipBillingOnAcceptance";
  StartBillingOnEnum["Earliest"] = "earliest";
  StartBillingOnEnum["StartPaused"] = "startPaused";
  return StartBillingOnEnum;
}({});
export let InvoicePaymentMethodStatus = /*#__PURE__*/function (InvoicePaymentMethodStatus) {
  InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
  InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
  return InvoicePaymentMethodStatus;
}({});
export let LineItemPendingApprovalReason = /*#__PURE__*/function (LineItemPendingApprovalReason) {
  LineItemPendingApprovalReason["AdHocCharge"] = "ad-hoc-charge";
  LineItemPendingApprovalReason["ServiceAmendment"] = "service-amendment";
  LineItemPendingApprovalReason["VariableExceedsCap"] = "variable-exceeds-cap";
  LineItemPendingApprovalReason["VariableZeroCap"] = "variable-zero-cap";
  LineItemPendingApprovalReason["RangeExceedsMaxPrice"] = "range-exceeds-max-price";
  LineItemPendingApprovalReason["VariableCumulative"] = "variable-cumulative";
  LineItemPendingApprovalReason["NonVariableCumulative"] = "non-variable-cumulative";
  LineItemPendingApprovalReason["OverlappingPeriod"] = "overlapping-period";
  return LineItemPendingApprovalReason;
}({});
export { InvoiceDisputedFailureCode };
export let IntegrationStatus = /*#__PURE__*/function (IntegrationStatus) {
  IntegrationStatus["Error"] = "error";
  IntegrationStatus["Linked"] = "linked";
  IntegrationStatus["Unlinked"] = "unlinked";
  return IntegrationStatus;
}({});
export let PracticeManagement = /*#__PURE__*/function (PracticeManagement) {
  PracticeManagement["Keeper"] = "keeper";
  PracticeManagement["Karbon"] = "karbon";
  PracticeManagement["ClientHub"] = "client-hub";
  PracticeManagement["FinancialCents"] = "financial-cents";
  return PracticeManagement;
}({});
export let Accounting = /*#__PURE__*/function (Accounting) {
  Accounting["QBO"] = "qbo";
  Accounting["Xero"] = "xero";
  return Accounting;
}({});
export let IntegrationResponseStatus = /*#__PURE__*/function (IntegrationResponseStatus) {
  IntegrationResponseStatus["Success"] = "success";
  IntegrationResponseStatus["Error"] = "error";
  return IntegrationResponseStatus;
}({});
export const isPracticeManagementIntegrationItem = value => value.id !== undefined;
export function getSelectedUser(users, role, service, getIntegration) {
  const asignToUser = s => {
    var _getIntegration;
    const assignedUserId = (_getIntegration = getIntegration(s)) === null || _getIntegration === void 0 ? void 0 : _getIntegration.assignedUserId(role.id);
    return assignedUserId && users ? users.find(user => user.id === assignedUserId) || null : null;
  };
  if (service.bundle) {
    return service.bundle.services.map(asignToUser).find(user => user !== null) || null;
  }
  return asignToUser(service);
}
export const isAccountingQbo = accounting => accounting === Accounting.QBO;
export const isAccountingXero = accounting => accounting === Accounting.Xero;